<mat-accordion multi="false">
    <mat-expansion-panel *ngFor="let release of releases; let isFirst = first" [expanded]="isFirst">
        <mat-expansion-panel-header>
            <mat-panel-title>{{ release.date | date : "yyyy-MM-dd" }}</mat-panel-title>
            <mat-panel-description>{{ 'help.changelog.version.shortLabel' | translate }} {{ release.version }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="release-rubric" *ngFor="let rubric of release.rubrics">
            <h3>{{ rubric.label }}</h3>
            <mat-list>
                <mat-list-item *ngFor="let change of rubric.changes">
                    <mat-icon class="list-icon" matListIcon *ngIf="change.category.icon"
                        [matTooltip]="change.category.label">{{ change.category.icon }}</mat-icon>
                    <p class="release-rubric">{{ change.text }}</p>
                </mat-list-item>
            </mat-list>
        </div>
    </mat-expansion-panel>
</mat-accordion>
